// import { useEffect, useState } from "react";
// import { Link, useLocation } from "react-router-dom";

// const SideBar = () => {
//     const [openMenu, setOpenMenu] = useState(null);
//     const location = useLocation();

//     const toggleMenu = (index) => {
//         setOpenMenu(openMenu === index ? null : index);
//     };

//     const closeSidebar = () => {
//         document.body.classList.remove("sidebar-open");
//     };

//     useEffect(() => {
//         // cleanup if sidebar was left open
//         return () => {
//             document.body.classList.remove("sidebar-open");
//         };
//     }, []);

//     const SideMenu = [
//         {
//             name: "Dashboard",
//             icon: "icon-icon-18",
//             link: "/dashboard",
//         },
//         {
//             name: "My Team",
//             icon: "icon-icon-19",
//             link: "/my-team",
//         },
//         {
//             name: "Buildings",
//             icon: "icon-icon-20",
//             link: "/buildings",
//         },
//         {
//             name: "Create Key",
//             icon: "icon-icon-21",
//             link: "/create-key",
//         },
//         {
//             name: "Import Data",
//             icon: "icon-icon-22",
//             link: "/import-data",
//         },
//         {
//             name: "Calculations",
//             icon: "icon-icon-23",
//             link: "/calculations",
//         },
//         {
//             name: "Reports",
//             icon: "icon-icon-24",
//             link: "/reports",
//         },
//         {
//             name: "My Account",
//             icon: "icon-icon-25",
//             link: "#",
//             subMenu: [
//                 {
//                     name: "My Profile",
//                     icon: "icon-icon-26",
//                     link: "/my-profile",
//                 },
//                 {
//                     name: "Change Password",
//                     icon: "icon-icon-27",
//                     link: "/change-password",
//                 },
//             ],
//         },
//     ];

//     return (
//         <div className="sidebar">
//             <button className="close-button" onClick={closeSidebar}>
//                 <i className="icon-icon-14"></i>
//             </button>
//             <ul className="sidebar-menu">
//                 {SideMenu.map((item, index) => {
//                     // Check active state
//                     const isActive =
//                         location.pathname === item.link ||
//                         (item.subMenu &&
//                             item.subMenu.some((sub) => location.pathname === sub.link));

//                     return (
//                         <li
//                             key={index}
//                             className={`sidebar-item ${isActive ? "active" : ""}`}
//                         >
//                             {item.subMenu ? (
//                                 <>
//                                     <button
//                                         className={`sidebar-link d-flex align-items-center justify-content-between w-100 ${openMenu === index ? "open" : ""
//                                             }`}
//                                         onClick={() => toggleMenu(index)}
//                                     >
//                                         <span className="d-flex align-items-center">
//                                             <span className="icon">
//                                                 <i className={item.icon}></i>
//                                             </span>
//                                             <span>{item.name}</span>
//                                         </span>
//                                         <i
//                                             className={`icon-arrow ${openMenu === index ? "icon-icon-7 rotate" : "icon-icon-7"
//                                                 }`}
//                                         ></i>
//                                     </button>
//                                     {openMenu === index && (
//                                         <ul className="submenu list-unstyled">
//                                             {item.subMenu.map((sub, subIndex) => {
//                                                 const isSubActive = location.pathname === sub.link;
//                                                 return (
//                                                     <li
//                                                         key={subIndex}
//                                                         className={`sidebar-subitem ${isSubActive ? "active" : ""
//                                                             }`}
//                                                     >
//                                                         <Link
//                                                             to={sub.link}
//                                                             className="d-flex align-items-center sidebar-sublink"
//                                                         >
//                                                             <span className="icon">
//                                                                 <i className={sub.icon}></i>
//                                                             </span>
//                                                             <span>{sub.name}</span>
//                                                         </Link>
//                                                     </li>
//                                                 );
//                                             })}
//                                         </ul>
//                                     )}
//                                 </>
//                             ) : (
//                                 <Link
//                                     to={item.link}
//                                     className={`sidebar-link d-flex align-items-center ${isActive ? "active" : ""
//                                         }`}
//                                 >
//                                     <span className="icon">
//                                         <i className={item.icon}></i>
//                                     </span>
//                                     <span>{item.name}</span>
//                                 </Link>
//                             )}
//                         </li>
//                     );
//                 })}
//             </ul>
//             <div className="signout-button">
//                 <button className="btns d-flex align-items-center justify-content-center">
//                     <span className="icon">
//                         <i className="icon-icon-28"></i>
//                     </span>
//                     Sign Out
//                 </button>
//             </div>
//         </div>
//     );
// };

// export default SideBar;

import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

const SideBar = () => {
  const [openMenu, setOpenMenu] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  const toggleMenu = (index) => {
    setOpenMenu(openMenu === index ? null : index);
  };

  const closeSidebar = () => {
    document.body.classList.remove("sidebar-open");
  };

  useEffect(() => {
    return () => {
      document.body.classList.remove("sidebar-open");
    };
  }, []);

  // 🔹 get user details from localStorage (or context if you prefer)
  const user = JSON.parse(localStorage.getItem("user")) || {};
  const accessLevel = user?.access_level;

  const handleLogout = async () => {
    closeSidebar();
    try {
      await axios.get(`${process.env.REACT_APP_API_URL}auth/logout`, {
        headers: {
          "api-key": process.env.REACT_APP_API_KEY,
          Authorization: `Bearer ${user?.token || localStorage.getItem("token")}`,
        },
      });
    } catch (err) {
      console.error("Logout failed", err);
    } finally {
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      navigate("/login");
    }
  };

  // 🔹 Full menu
  const SideMenu = [
    {
      name: "Dashboard",
      icon: "icon-icon-18",
      link: "/dashboard",
    },
    {
      name: "My Team",
      icon: "icon-icon-19",
      link: "/my-team",
    },
    {
      name: "Buildings",
      icon: "icon-icon-20",
      link: "/buildings",
    },
    {
      name: "Create Key",
      icon: "icon-icon-21",
      link: "/create-key",
    },
    {
      name: "Keys",
      icon: "icon-icon-21",
      link: "/keys",
    },
    {
      name: "Import Data",
      icon: "icon-icon-22",
      link: "/import-data",
    },
    {
      name: "Imported Data",
      icon: "icon-icon-29",
      link: "#",
      subMenu: [
        {
          name: "Surface Data",
          link: "/imported-data/surface",
        },
        {
          name: "Cost Data",
          link: "/imported-data/cost",
        },
        {
          // Phase 3 (A10): per-invoice cost detail (sibling to "Cost Data" which
          // holds the aggregate totals). Backed by the new tbl_cost_invoice table.
          name: "Cost Invoices",
          link: "/imported-data/cost_invoice",
        },
        {
          name: "Energy Consumption",
          link: "/imported-data/consumption",
        },
        {
          name: "Object Data",
          link: "/imported-data/object",
        },
        {
          name: "ETC Data",
          link: "/imported-data/etc",
        },
        {
          name: "DJF Data",
          link: "/imported-data/djf",
        },
        {
          name: "NJ Data",
          link: "/imported-data/nj",
        },
      ],
    },
    {
      name: "Calculations",
      icon: "icon-icon-23",
      link: "/calculations",
    },
    {
      name: "Result II",
      icon: "icon-icon-23",
      link: "/result-ii",
    },
    {
      name: "Reports",
      icon: "icon-icon-24",
      link: "/reports",
    },
    {
      // Phase 3 (B1): entry point for the Répartition annual distribution PDF.
      // Reuses the same icon family as Reports since it's a sibling report flow.
      name: "Répartition Report",
      icon: "icon-icon-24",
      link: "/repartition-report",
    },
    {
      name: "My Account",
      icon: "icon-icon-25",
      link: "#",
      subMenu: [
        {
          name: "My Profile",
          icon: "icon-icon-26",
          link: "/my-profile",
        },
        {
          name: "Change Password",
          icon: "icon-icon-27",
          link: "/change-password",
        },
      ],
    },
  ];

  // 🔹 If access_level = 2 → filter menu (limited access cannot see Keys / Create Key / My Team)
  const filteredMenu =
    accessLevel === 2
      ? SideMenu.filter((item) =>
          ["Dashboard", "Buildings", "Import Data", "Imported Data", "Calculations", "Result II", "Reports", "Répartition Report", "My Account"].includes(
            item.name
          )
        )
      : SideMenu;

  // Auto-expand the submenu that contains the active route
  useEffect(() => {
    const activeIndex = filteredMenu.findIndex(
      (item) =>
        item.subMenu &&
        item.subMenu.some((sub) => location.pathname.startsWith(sub.link))
    );
    if (activeIndex !== -1) {
      setOpenMenu(activeIndex);
    }
  }, [location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="sidebar">
      <button className="close-button" onClick={closeSidebar}>
        <i className="icon-icon-14"></i>
      </button>
      <ul className="sidebar-menu">
        {filteredMenu.map((item, index) => {
          const isActive =
            location.pathname === item.link ||
            (item.subMenu && item.subMenu.some((sub) => location.pathname === sub.link));

          return (
            <li key={index} className={`sidebar-item ${isActive ? "active" : ""}`}>
              {item.subMenu ? (
                <>
                  <button
                    className={`sidebar-link d-flex align-items-center justify-content-between w-100 ${
                      openMenu === index ? "open" : ""
                    }`}
                    onClick={() => toggleMenu(index)}
                  >
                    <span className="d-flex align-items-center">
                      <span className="icon">
                        <i className={item.icon}></i>
                      </span>
                      <span>{item.name}</span>
                    </span>
                    <i
                      className={`icon-arrow ${
                        openMenu === index ? "icon-icon-7 rotate" : "icon-icon-7"
                      }`}
                    ></i>
                  </button>
                  {openMenu === index && (
                    <ul className="submenu list-unstyled">
                      {item.subMenu.map((sub, subIndex) => {
                        const isSubActive = location.pathname === sub.link;
                        return (
                          <li
                            key={subIndex}
                            className={`sidebar-subitem ${isSubActive ? "active" : ""}`}
                          >
                            <Link
                              to={sub.link}
                              className="d-flex align-items-center sidebar-sublink"
                            >
                              {sub.icon && (
                                <span className="icon">
                                  <i className={sub.icon}></i>
                                </span>
                              )}
                              <span>{sub.name}</span>
                            </Link>
                          </li>
                        );
                      })}
                    </ul>
                  )}
                </>
              ) : (
                <Link
                  to={item.link}
                  className={`sidebar-link d-flex align-items-center ${isActive ? "active" : ""}`}
                >
                  <span className="icon">
                    <i className={item.icon}></i>
                  </span>
                  <span>{item.name}</span>
                </Link>
              )}
            </li>
          );
        })}
      </ul>
      <div className="signout-button">
        <button
          type="button"
          className="btns d-flex align-items-center justify-content-center"
          onClick={handleLogout}
        >
          <span className="icon">
            <i className="icon-icon-28"></i>
          </span>
          Sign Out
        </button>
      </div>
    </div>
  );
};

export default SideBar;